export const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const parse = (s) => new Date(`${s}T00:00:00`);
const addDays = (s, n) => { const d = parse(s); d.setDate(d.getDate() + n); return ymd(d); };
const monday = (s) => { const d = parse(s); return addDays(s, -((d.getDay() + 6) % 7)); };
const monthStart = (s) => `${s.slice(0, 7)}-01`;
const monthEnd = (s) => { const d = parse(monthStart(s)); return ymd(new Date(d.getFullYear(), d.getMonth() + 1, 0)); };
const addMonths = (s, n) => { const d = parse(monthStart(s)); return ymd(new Date(d.getFullYear(), d.getMonth() + n, 1)); };
const short = (s, o) => parse(s).toLocaleDateString("en-NZ", o);

export const stepAnchor = (view, scale, anchor, dir) =>
  view === "board" && scale === "day" ? addDays(anchor, 7 * dir) : addMonths(anchor, dir);

export const buildColumns = (scale, anchor) => {
  if (scale === "day") {
    const mon = monday(anchor);
    return [...Array(7)].map((_, i) => {
      const d = addDays(mon, i);
      return { key: d, label: short(d, { weekday: "short" }), sub: short(d, { day: "numeric", month: "short" }), start: d, end: d };
    });
  }
  if (scale === "week") {
    const cols = [];
    for (let w = monday(monthStart(anchor)), i = 1; w <= monthEnd(anchor); w = addDays(w, 7), i++) {
      const e = addDays(w, 6);
      cols.push({ key: w, label: `Week ${i}`, sub: `${short(w, { day: "numeric", month: "short" })} – ${short(e, { day: "numeric", month: "short" })}`, start: w, end: e });
    }
    return cols;
  }
  return [0, 1, 2].map((i) => {
    const m = addMonths(anchor, i);
    return { key: m, label: short(m, { month: "long" }), sub: short(m, { year: "numeric" }), start: m, end: monthEnd(m) };
  });
};

export const calendarRange = (anchor) => {
  const s = monday(monthStart(anchor));
  const e = addDays(monday(monthEnd(anchor)), 6);
  return { start: s, end: e };
};

export const dropDate = (scale, col, oldDate) => {
  if (scale === "day") return col.start;
  if (scale === "week") return addDays(col.start, (parse(oldDate).getDay() + 6) % 7);
  const day = Math.min(Number(oldDate.slice(8, 10)), Number(col.end.slice(8, 10)));
  return `${col.start.slice(0, 8)}${String(day).padStart(2, "0")}`;
};

export const eventsInRange = (events, start, end) => {
  const seen = new Set();
  return events.filter((e) => {
    const inside = e.type === "hire" ? e.start <= end && e.end >= start : e.date >= start && e.date <= end;
    const k = `${e.type}-${e.id}`;
    if (!inside || seen.has(k)) return false;
    seen.add(k);
    return true;
  }).sort((a, b) => (a.date + (a.time || "")).localeCompare(b.date + (b.time || "")));
};

export const rangeLabel = (view, scale, anchor) => {
  if (view === "board" && scale === "day") {
    const mon = monday(anchor);
    return `${short(mon, { day: "numeric", month: "short" })} – ${short(addDays(mon, 6), { day: "numeric", month: "short", year: "numeric" })}`;
  }
  if (view === "board" && scale === "month") return `${short(anchor, { month: "short" })} – ${short(addMonths(anchor, 2), { month: "short", year: "numeric" })}`;
  return short(anchor, { month: "long", year: "numeric" });
};
